import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UtilserviceService } from './services/utilservice.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(private router: Router, private auth: UtilserviceService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.authChecker(state);
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.authChecker(state);
  }

  authChecker(state: RouterStateSnapshot) {
    let user = JSON.parse(this.auth.getCurrentUser());
    if(user == null){
      this.router.navigate(["/login"], { queryParams: { url: state.url } });
      return false;
    }

    if (user['token'] != null) {
      return true;
    } else {
      this.router.navigate(["/login"], { queryParams: { url: state.url } });
      return false;
    }
  }
}
